// Author Lin
// Date 2021-05-06 11:55:20

import * as model from "@/model/sithMes/mst/SithMesMstBasicHeaderModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstBasicHeader(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'sithMesMstBasicHeader',
        modelFilter: model.filter
    })
    .buildStore()
